"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTextEditor = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
// components/QuillEditor.js
var react_1 = require("react");
var react_quill_1 = __importDefault(require("react-quill"));
require("react-quill/dist/quill.snow.css");
var FormInputLabel_1 = __importDefault(require("./FormInputLabel"));
var ACTextEditor = function (props) {
    var _a;
    var _b = (0, react_1.useState)(props.value), value = _b[0], setValue = _b[1];
    (0, react_1.useEffect)(function () {
        setValue(props.value);
    }, [props.value]);
    var handleChange = function (val) {
        setValue(val);
        props.onChange && props.onChange(val);
    };
    var modules = {
        toolbar: (props === null || props === void 0 ? void 0 : props.showToolbar) && !(props === null || props === void 0 ? void 0 : props.disabled)
            ? [
                // [{ size: [] }], // Typography
                ['bold', 'italic', 'underline'], // Formatting
                [{ list: 'ordered' }, { list: 'bullet' }], // Lists
            ]
            : false,
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: props.containerClassName, children: [(0, jsx_runtime_1.jsx)(FormInputLabel_1.default, __assign({}, props)), (0, jsx_runtime_1.jsx)(react_quill_1.default, { theme: "snow", value: value, onChange: handleChange, readOnly: props === null || props === void 0 ? void 0 : props.disabled, placeholder: props.placeholder || 'Start writing here...', className: (_a = "apx-ui_text__editor ".concat((props === null || props === void 0 ? void 0 : props.color) || '', " ").concat(props.className)) === null || _a === void 0 ? void 0 : _a.trim(), modules: modules })] }));
};
exports.ACTextEditor = ACTextEditor;
